'use strict';

var RomAnalysisToolbarController = function RomAnalysisToolbarController($scope, $rootScope, searchCriteriaConstantsService, featureToggleService) {
  $scope.initialScreen = searchCriteriaConstantsService.ROM_ANALYSIS;
  $scope.cogValue = 'romAnalysisToolbar';
  $scope.cogOptionsSet = require('../config/cogOptionsSet');
  $scope.cogOptionsSet.defaults = {
    'no-submenu': {
      'no-group': featureToggleService.isEnabled('MAPPED_MODE') ? ['REGULAR'] : ['MAPPED']
    }
  };
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
};
RomAnalysisToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'FeatureToggleService'];
module.exports = RomAnalysisToolbarController;